export const ru = {
    'active-status': 'Активно',
    'age-limit': 'Возрастные ограничения информационных услуг',
    'archived-status': 'В архиве',
    'audio-creatives': 'Аудиокреативы',
    'banner-adaptive-image': 'Адаптив',
    'banner-body': 'Текст вашего объявления о рекламе услуги или товара.',
    'banner-domain': 'домен',
    'banner-href-choose-protocol': 'Выберите протокол',
    'banner-href-domain-invalid': 'Неверный формат домена',
    'banner-href-http-invalid': 'Ваш сервер вернул ошибку: 404 Not Found',
    'banner-href-http-timeout': 'Ваш сервер вернул ошибку: 400 unavailable',
    'banner-href-invalid': 'Неправильный формат ссылки',
    'banner-href-null': 'Ссылка не может быть пустой',
    'banner-price': 'Цены в объявлениях',
    'banner-title': 'Заголовок объявления',
    'banner-type-content-promotion-collection': 'Продвижение Яндекс Коллекции',
    'banner-type-content-promotion-video': 'Продвижение Яндекс Видео',
    'banner-type-cpc_video': 'Видео',
    'banner-type-cpm-indoor': 'Реклама в помещениях',
    'banner-type-cpm_audio': 'Аудио',
    'banner-type-cpm_banner': 'Медийный баннер',
    'banner-type-cpm_geoproduct': 'Баннер в Яндекс.Метро',
    'banner-type-cpm_geoproduct-new': 'Баннер на гео-площадках',
    'banner-type-cpm_outdoor': 'Наружная реклама',
    'banner-type-cpm_video': 'Медийное видео',
    'banner-type-dynamic': 'Динамическое объявление',
    'banner-type-image_ad': 'Графическое объявление',
    'banner-type-internal': 'Объявление типа internal',
    'banner-type-internal-autobudget': 'Автобюджетная кампания',
    'banner-type-internal-distrib': 'Дистрибуционное объявление',
    'banner-type-internal-free': 'Бесплатное объявление',
    'banner-type-mcbanner': 'Баннер на поиске',
    'banner-type-mobile_content': 'Реклама мобильных приложений',
    'banner-type-performance': 'Смарт-баннер',
    'banner-type-text': 'Текстово-графическое объявление',
    'banner-type-text-mobile': 'Текстово-графическое объявление мобильное',
    callouts: 'Уточнения',
    'callouts-resource-name': 'уточнения',
    'callouts-resource-rejected': 'Уточнения отклонены на модерации',
    'child-age-limit': 'Возрастные ограничения детского питания',
    'choose-creatives-presets': 'Выбрать из ранее созданных',
    'choose-gallery': 'Выбрать из ранее загруженных',
    contactPerson: 'Клиент',
    counters: 'Счётчик показов',
    'cpm-image-creative': 'Креативы',
    'created-creatives': 'Готовые креативы',
    'creative-help':
        'Создайте креатив самостоятельно {constructor} или добавьте готовый креатив, который {requirements}',
    'creative-help-mc-banner': 'Добавьте готовый креатив, который {requirements}',
    creatives: 'Креативы',
    'creatives-constructor': 'Конструктор креативов',
    'creatives-ideas': 'Идеи креативов',
    'creatives-resource-name': 'креативы',
    'creatives-resource-rejected': 'Креативы отклонены на модерации',
    default: 'Выбрать',
    'display-href-resource-name': 'отображаемая ссылка',
    'display-href-resource-rejected': 'Отображаемая ссылка отклонена на модерации',
    'draft-status': 'Черновик',
    icq: 'ICQ',
    'image-creative': 'Графические креативы',
    images: 'Изображения',
    'images-resource-name': 'изображение',
    'images-resource-rejected': 'Изображение отклонено на модерации',
    'in-constructor': 'в конструкторе',
    'is-previous-version-shown': 'Идут показы предыдущей версии',
    'is-rejected-on-moderation': 'Отклонено модерацией',
    jabber: 'Jabber/GTalk',
    link: 'Заменить ссылку целиком',
    'link-groups-mass-action': 'Изменить ссылки',
    'link-replace': 'Часть ссылки',
    'link-title': 'Ссылка на сайт или соцсеть',
    mailru: 'MailRu Агент',
    'manually-suspended-status': 'Остановлено',
    'moderation-rejected-status': 'Отклонено на модерации',
    'moderation-status': 'На модерации',
    'not-grouped-mass-action': 'Всё остальное',
    'on-video-creative-close': 'Несохраненные изменения будут потеряны. Продолжить?',
    'organization-title': 'Организация из Яндекс.Справочника',
    pixel: 'Пиксель Яндекс.Аудиторий',
    'placement-pages-rejected': 'Не выбрано подходящих щитов',
    'preset-adaptive': 'Адаптивный шаблон',
    'preset-create-new': 'Создать новый',
    price: 'Цена в объявлении',
    'rejected-on-moderation-resources': 'Отклонены на модерации: {resources}',
    requirements: 'соответствует требованиям',
    'site-links': 'Быстрые ссылки',
    sitelink: 'Быстрая ссылка',
    'sitelinks-resource-name': 'быстрые ссылки',
    'sitelinks-resource-rejected': 'Быстрые ссылки отклонены на модерации',
    skype: 'Skype',
    'standard-image': 'Стандартное изображение',
    telegram: 'Telegram',
    'temporarly-suspended-status': 'Приостановлено мониторингом',
    'text-groups-mass-action': 'Текст в объявлениях',
    'text-path-replace': 'Найти и заменить',
    tracking: 'Трекинговые параметры',
    turbo: 'Турбо-страницы',
    'turbo-gallery': 'Показы в турбо-галерее',
    'turbo-title': 'Турбо-страница',
    turbolanding: 'Турбо-страница',
    'turbolandings-resource-name': 'турбо-страница',
    'turbolandings-resource-rejected': 'Турбо-страница отклонена на модерации',
    'upload-link': 'Загрузить по ссылке',
    'upload-local': 'Загрузить с компьютера',
    'vcard-resource-name': 'контактная информация',
    'vcard-resource-rejected': 'Контактная информация отклонена на модерации',
    'vcard-title': 'Виртуальная визитка',
    viber: 'Viber',
    video: 'Видеодополнения',
    'video-addition': 'Видеодополнение',
    'video-addtions-resource-name': 'видеодополнение',
    'video-addtions-resource-rejected': 'Видеодополнение отклонено на модерации',
    'video-body-placeholder': 'Описание видео',
    'video-creatives': 'Видеокреативы',
    'video-title-placeholder': 'Заголовок видео',
    'visible-domain': 'Домен',
    'visible-link-replace': 'Отображаемые ссылки',
    whatsapp: 'Whatsapp',
    'wide-image': 'Широкоформатное изображение',
    'yandex-collections': 'Яндекс.Коллекции',
    'yandex-video': 'Яндекс.Видео'
};
